<template>
  <div>
    <div
      class="dropdown is-right"
      :class="{
        'is-active': open,
      }">
      <div class="dropdown-trigger">
        <a @click="open = !open">
          <b-icon
            id="icon"
            icon="map-marker"
            :style="{ color: value }">
          </b-icon>
        </a>
      </div>
      <div class="dropdown-menu colorPicker" role="menu">
        <div class="dropdown-content">
          <div class="dropdown-item">
            <compact-picker class="p-0" v-model="color" @input="update()"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Compact } from 'vue-color';

export default {
  props: {
    value: String,
  },
  data() {
    return {
      color: { hex: '' },
      open: false,
    };
  },
  components: {
    'compact-picker': Compact,
  },
  methods: {
    update() {
      this.open = !this.open;
      this.$emit('input', this.color.hex);
    },
  },
  mounted() {
    this.color = this.value;
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/general/colorMarker.vue